module.exports = __webpack_public_path__ + "static/media/ic-app-menu.5be42785.svg";